import React from 'react';

import PropTypes from 'prop-types';

function PauseIcon2({ width = 12, height = 12, color = '#1B1C19', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      {...rest}
    >
      <path
        d="M11 1V11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12H7.5C7.23478 12 6.98043 11.8946 6.79289 11.7071C6.60536 11.5196 6.5 11.2652 6.5 11V1C6.5 0.734784 6.60536 0.48043 6.79289 0.292893C6.98043 0.105357 7.23478 0 7.5 0H10C10.2652 0 10.5196 0.105357 10.7071 0.292893C10.8946 0.48043 11 0.734784 11 1ZM3.5 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H3.5C3.76522 12 4.01957 11.8946 4.20711 11.7071C4.39464 11.5196 4.5 11.2652 4.5 11V1C4.5 0.734784 4.39464 0.48043 4.20711 0.292893C4.01957 0.105357 3.76522 0 3.5 0Z"
        fill={color}
      />
    </svg>
  );
}

PauseIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default PauseIcon2;
